// **Die Routentabelle** — rein, ohne React, getestet (routes.test.ts). Dieselben
// Pfade wie die Vanilla-Fassung; was keiner Route entspricht, ist „not-found".

export type Route =
  | { name: "dashboard" }
  | { name: "tenants" }
  | { name: "wizard-new" }
  | { name: "wizard"; id: number; step: number }
  | { name: "detail"; id: number; tab: string }
  | { name: "licenses" }
  | { name: "license"; id: number | "new" }
  | { name: "feedback" }
  | { name: "feedback-report"; id: number }
  | { name: "costs" }
  | { name: "audit" }
  | { name: "versions" }
  | { name: "not-found" };

/** Ein abschließender Schrägstrich ändert nichts: `/tenants/` ist `/tenants`. */
export function normalizePath(pathname: string): string {
  return pathname.replace(/\/+$/, "") || "/";
}

export function matchRoute(pathname: string): Route {
  const path = normalizePath(pathname);
  if (path === "/") return { name: "dashboard" };
  if (path === "/tenants") return { name: "tenants" };
  if (path === "/tenants/new") return { name: "wizard-new" };
  let m = /^\/tenants\/(\d+)\/wizard\/(\d)$/.exec(path);
  // Der Schritt wird auf 1…7 begrenzt, „0" ist Schritt 1 (wie früher).
  if (m) return { name: "wizard", id: Number(m[1]), step: Math.min(7, Math.max(1, Number(m[2]) || 1)) };
  m = /^\/tenants\/(\d+)(?:\/([a-z]+))?$/.exec(path);
  if (m) return { name: "detail", id: Number(m[1]), tab: m[2] ?? "" };
  m = /^\/licenses(?:\/(\d+|new))?$/.exec(path);
  if (m) return m[1] ? { name: "license", id: m[1] === "new" ? "new" : Number(m[1]) } : { name: "licenses" };
  m = /^\/feedback(?:\/(\d+))?$/.exec(path);
  if (m) return m[1] ? { name: "feedback-report", id: Number(m[1]) } : { name: "feedback" };
  if (path === "/costs") return { name: "costs" };
  if (path === "/audit") return { name: "audit" };
  if (path === "/versions") return { name: "versions" };
  return { name: "not-found" };
}

/** Die Navigation links: Ziel, Wort, und wann der Eintrag „aktiv" ist. */
export const NAV: ReadonlyArray<readonly [string, string, (path: string) => boolean]> = [
  ["/", "Übersicht", (p) => p === "/"],
  ["/tenants", "Mandanten", (p) => p.startsWith("/tenants")],
  ["/feedback", "Feedback", (p) => p.startsWith("/feedback")],
  ["/licenses", "Lizenzen", (p) => p.startsWith("/licenses")],
  ["/costs", "Kosten", (p) => p.startsWith("/costs")],
  ["/audit", "Plattform-Audit", (p) => p.startsWith("/audit")],
  ["/versions", "Versionen", (p) => p.startsWith("/versions")],
];

/** Ein Klick, den der Browser selbst behandeln soll (neuer Tab, Fenster, Download …). */
export function isModifiedClick(e: { button: number; metaKey: boolean; ctrlKey: boolean; shiftKey: boolean; altKey: boolean }): boolean {
  return e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
}
